"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'basic',
  id: 'basic',
  groups: [{
    symbols: [{
      latex: '\\frac',
      icon: '\\frac{&#x25FB;}{&#x25FB;}',
      title: 'fraction'
    }, {
      latex: '\\sqrt',
      icon: '\\sqrt{&#x25FB;}',
      title: 'square root'
    }, {
      latex: '\\sqrt[3]{}',
      icon: '\\sqrt[3]{&#x25FB;}',
      title: 'cube root',
      isCommand: false
    }, {
      latex: '\\supscript',
      icon: '&#x25A1;^{&#x25FB;}_{\\ }',
      title: 'superscript'
    }, {
      latex: '\\subscript',
      icon: '&#x25A1;^{\\ }_{&#x25FB;}',
      title: 'subscript'
    }, {
      latex: '\\times',
      icon: '\\times',
      title: 'multiply'
    }, {
      latex: '\\div',
      icon: '\\div',
      title: 'divide'
    }]
  }, {
    symbols: [{
      latex: '\\pi',
      icon: '\\pi',
      title: 'pi'
    }, {
      latex: '\\le',
      icon: '\\le',
      title: 'less than or equal'
    }, {
      latex: '\\ge',
      icon: '\\ge',
      title: 'greater than or equal'
    }, {
      latex: '\\longleftarrow',
      icon: '\\longleftarrow',
      title: 'left arrow'
    }, {
      latex: '\\longrightarrow',
      icon: '\\longrightarrow',
      title: 'right arrow'
    }, {
      latex: '\\degree',
      icon: '\\degree',
      title: 'degrees'
    }]
  }]
}];
var _default2 = _default;
exports.default = _default2;
module.exports = exports["default"];
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, "default", "/opt/TeamCity/buildAgent2/work/63f390c34456f15a/src/menuConfigs/menu-k12-en.js");
}();

;